'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = filterImgSrc;

var _parseSrcset = require('../utils/parseSrcset');

var _parseSrcset2 = _interopRequireDefault(_parseSrcset);

var _findClosestDpr = require('../utils/findClosestDpr');

var _findClosestDpr2 = _interopRequireDefault(_findClosestDpr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterImgSrc(_ref) {
  var _ref$dataset = _ref.dataset,
      src = _ref$dataset.src,
      srcset = _ref$dataset.srcset;

  if (!srcset) return src;

  // $FlowIgnoreLine: DOM api
  var clientWidth = document.documentElement.clientWidth || window.innerWidth; // eslint-disable-line no-undef
  var devicePixelRatio = window.devicePixelRatio; // eslint-disable-line no-undef
  var parsedSrcset = (0, _parseSrcset2.default)(srcset);
  var srcInArray = parsedSrcset.map(function (s) {
    return _extends({}, s, !s.dpr && s.width ? { dpr: s.width / clientWidth } : null);
  });
  var foundSrc = srcInArray.find(function (_ref2) {
    var dpr = _ref2.dpr;
    return devicePixelRatio === dpr;
  });

  return foundSrc ? foundSrc.url : (0, _findClosestDpr2.default)(srcInArray, devicePixelRatio).url;
}